import { createAsyncThunk } from "@reduxjs/toolkit";
import { getGeozoneAssignedObjects } from "domain/geozones/api/get-geozone-assigned-objects";

export const getGeozoneAssignedObjectsAction = createAsyncThunk(
  "geozones/getGeozoneAssignedObjectsAction",
  async ({
    accountId,
    geozoneId
  }: {
    accountId: string;
    geozoneId: string;
  }) => {
    try {
      return await getGeozoneAssignedObjects({ accountId, geozoneId });
    } catch (e: any) {
      console.error(e);
      throw new Error(e);
    }
  }
);
